import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {first, takeUntil} from 'rxjs/operators';

import {fuseAnimations} from '@fuse/animations';
import {CategoryService} from "../../../services/category.service";
import {AlertService} from "../../../services";
import {NestedTreeControl} from "@angular/cdk/tree";
import {Category} from "../../../models/category";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {CategoryDialogComponent} from "../../../category/dialog/categoryDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'service-main-sidebar',
    templateUrl: './main-sidebar.component.html',
    styleUrls: ['./main-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ServiceMainSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    categories: any[];
    loadingIndicator: boolean;
    dialogRef: any;
    treeControl = new NestedTreeControl<Category>(node => node.children);
    dataSource = new MatTreeNestedDataSource<Category>();
    loading = false;
    @Output() filteredCategory = new EventEmitter<string>();

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router,
        public _matDialog: MatDialog,
        private categoryService: CategoryService,
        private alertService: AlertService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;
        this.dataSource.data = [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.categoryService.getAllMainByType('service').subscribe((res: any[]) => {
            this.categories = res;
            this.dataSource.data = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New service
     */
    newService(): void {
        this._router.navigate(['/services/new']).then(() => {

        });
    }

    hasChild = (_: number, node: Category) => !!node.children && node.children.length > 0;

    filterListByCategory(id: string|null): void {
        this.filteredCategory.emit(id);
    }

    public editCategory(category: Category) {
        this.dialogRef = this._matDialog.open(CategoryDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                action: 'edit',
                categories: this.categories,
                category: category,
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                console.log(response);
                let category = response.getRawValue();
                category.type = 'service';

                this.categoryService.update(category.id, category)
                    .pipe(first())
                    .subscribe(
                        data => {
                            this.alertService.success('Category saved successfully', {keepAfterRouteChange: true});

                            window.location.reload();
                        },
                        error => {
                            this.alertService.error(error);
                            this.loading = false;
                        });

            }, (err) => {
                console.log(err);
            });
    }
}
